import {Fragment} from 'react';
import {KeenIcon} from '@/components';
import {Container} from '@/components/container';
import {toAbsoluteUrl} from '@/utils';
import {CandidateDetailsData} from '@/pages/buddy/types/CandidateDetailsData.ts';

interface CandidateProfileHeroProps {
    candidate: CandidateDetailsData;
}

const CandidateProfileHero = ({candidate}: CandidateProfileHeroProps) => {
    return (
        <Fragment>
            <style>
                {`
                    .hero-bg {
                        background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-1.png')}');
                    }
                    .dark .hero-bg {
                        background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-1-dark.png')}');
                    }
                `}
            </style>
            <div className="bg-center bg-cover bg-no-repeat hero-bg">
                <Container>
                    <div className="flex flex-col items-center gap-2 lg:gap-3 py-4 lg:py-5">
                        <div
                            className="flex items-center justify-center rounded-full border-2 border-primary bg-light h-[100px] w-[100px]"
                        >
                            {candidate.image_url ? (
                                <img
                                    src={toAbsoluteUrl(candidate.image_url)}
                                    alt={candidate.last_name || 'Company image'}
                                    className="size-[50px] object-cover"
                                />
                            ) : (
                                <KeenIcon icon="user" className="default-color text-3xl"/>
                            )}
                        </div>

                        <div
                            className="text-2xl font-semibold text-gray-800 text-center">{candidate.first_name} {candidate.last_name}</div>

                        {candidate.email && (
                            <div className="flex items-center gap-1 text-gray-600 text-sm">
                                <KeenIcon icon="business" className="text-primary"/>
                                <KeenIcon icon="sms" className="text-primary"/>

                                <a href={`mailto:${candidate.email}`} className="no-underline hover:text-primary">
                                    {candidate.email}
                                </a>

                                <KeenIcon icon="phone" className="text-primary"/>

                                <a href={`tel:${candidate.phone}`} className="no-underline hover:text-primary">
                                    {candidate.phone}
                                </a>
                            </div>
                        )}

                        <div className="flex flex-col md:flex-row gap-2 items-center justify-center mt-2">
                            {candidate.country && (
                                <div className="flex items-center gap-1 text-gray-600 text-sm">
                                    <KeenIcon icon="tag" className="text-primary"/>
                                    <span>{candidate.address}, {candidate.country}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        </Fragment>
    );
};

export {CandidateProfileHero};
